import styled from "styled-components";

export const ModalOverlay = styled.div<{ $isClosing?: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	padding: 20px;
	box-sizing: border-box;
	opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
	transition: opacity 0.3s ease-in-out;
`;

export const ModalContainer = styled.div<{ $isClosing?: boolean }>`

	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 12px;
	padding: 32px;
	width: "auto";
	box-shadow: ${({ theme }) => theme.mixins.shadows.elevation4};
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
	text-align: center;
	opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
	transition: opacity 0.3s ease-in-out;
	will-change: opacity;
	font-family: "Inter", sans-serif;

	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		padding: 24px;
		max-width: calc(100vw - 40px);
	}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`;

export const ModalTitle = styled.h2`
  font-size: 22px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary300};
  margin: 0;
  text-align: left;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;